
define(['jquery', 'underscore', 'core', 'app-common/component/loader', 'template/report/data/files.htm', 'common/location', 'common/lib/jquery.datatables', 'common/lib/date'], function($, _, core, loader, filesReportTemplate, location) {
  var datatable, filesData, getIdByFileRow, initTable, isInitialLoad, isPaginationEvent;
  filesData = [];
  datatable = null;
  isInitialLoad = true;
  isPaginationEvent = false;
  initTable = function(element, noResultsMessage) {
    var columns, rowCallback, table;
    table = $(element).find('table');
    columns = [
      {
        aTargets: [0],
        sTitle: 'Date',
        mData: null,
        sClass: 'date_column',
        sWidth: '25%',
        bSearchable: false,
        mRender: function(data, type, full) {
          var date;
          date = Date.parse(full.uploadDate);
          return ("<span class='month-day'>" + (date.toString('MMM')) + " " + (date.toString('dd')) + "</span><br />") + ("<span class='year'>" + (date.getFullYear()) + "</span>");
        }
      }, {
        aTargets: [1],
        sTitle: 'File name',
        mData: 'displayName',
        sClass: 'vendor',
        sWidth: '60%',
        bSearchable: true
      }, {
        aTargets: [2],
        sTitle: 'Download',
        mData: null,
        sClass: 'actions_column',
        sWidth: '15%',
        bSearchable: false,
        mRender: function() {
          return '<div class="download-document backing-icon"><span class="ss-file ss-gizmo"></span></div>';
        }
      }
    ];
    rowCallback = function(row, data) {
      if ($(row).hasClass('file_row')) {
        return row;
      }
      $(row).attr('id', "file_id_" + data.id).addClass('file_row').addClass("file_id_" + data.id);
      return row;
    };
    $.fn.dataTableExt.sErrMode = 'throw';
    datatable = table.dataTable({
      aoColumnDefs: columns,
      fnRowCallback: rowCallback,
      oLanguage: {
        sEmptyTable: noResultsMessage
      },
      bInfo: true,
      bLengthChange: false,
      bFilter: true,
      bPaginate: true,
      iDisplayLength: 250,
      bDeferRender: true,
      bAutoWidth: false,
      bSort: false
    });
    datatable.on('click', '.download-document', function() {
      var id, row;
      row = $(this).closest('.file_row');
      id = getIdByFileRow(row);
      return document.location.href = "" + location.apiRoot + "/api/v1/file.json/" + id + "/download";
    });
    datatable.on('page.dt', function() {
      return isPaginationEvent = true;
    });
    datatable.on('draw.dt', function() {
      if (isInitialLoad) {
        isInitialLoad = false;
        return;
      }
      if (isPaginationEvent) {
        setTimeout(function() {
          var paginationElement, paginationTop, targetScroll, windowBottom;
          paginationElement = $('.dataTables_paginate');
          if (paginationElement.length) {
            paginationTop = paginationElement.offset().top;
            windowBottom = $(window).scrollTop() + $(window).height();
            if (paginationTop > windowBottom) {
              targetScroll = paginationTop - $(window).height() + paginationElement.outerHeight() + 50;
              return $(window).scrollTop(targetScroll);
            }
          }
        }, 100);
      }
      return isPaginationEvent = false;
    });
    if (filesData.length > 0) {
      return datatable.fnAddData(filesData);
    }
  };
  getIdByFileRow = function(row) {
    var rowId;
    rowId = $(row).attr('id').replace('file_id_', '');
    if (_.isNumber(rowId)) {
      return parseInt(rowId);
    } else {
      return rowId;
    }
  };
  return {
    search: function(searchString) {
      return datatable.fnFilter(searchString);
    },
    initReportTemplate: function(element, files) {
      $(element).html(filesReportTemplate);
      filesData = files;
      return initTable(element, 'You have no documents for the selected period.');
    }
  };
});
